import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=5c76a860&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"
import style0 from "./Pay.vue?vue&type=style&index=0&id=5c76a860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c76a860",
  null
  
)

export default component.exports